import appConfig from "../config/app.config";
import axios from "axios";
import { getUserToken } from "../libs/user";
import { handleError, startLoader, stopLoader } from "../libs/utils";

const getOfferStoresList = () => {
  startLoader();
  return new Promise((resolve, reject) => {
    var config = {
      method: "get",
      url: appConfig.apiUrl.listOfferStores,
      headers: {
        Authorization: `Bearer ${getUserToken()}`,
      },
    };

    axios(config)
      .then(function (response) {
        stopLoader();
        resolve(response.data);
      })
      .catch(function (error) {
        stopLoader();
        handleError({ error, reject });
      });
  });
};

const getOfferStoresdataById = (id) => {
  startLoader();
  return new Promise((resolve, reject) => {
    var config = {
      method: "get",
      url: `${appConfig.apiUrl.listOfferStores}/${id}`,
      headers: {
        Authorization: `Bearer ${getUserToken()}`,
      },
    };

    axios(config)
      .then(function (response) {
        stopLoader();
        resolve(response.data);
      })
      .catch(function (error) {
        stopLoader();
        handleError({ error, reject });
      });
  });
};

const updateOfferStores = (obj) => {
  startLoader(1);
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(obj);

    var config = {
      method: "post",
      url: `${appConfig.apiUrl.listOfferStores}/save`,
      headers: {
        Authorization: `Bearer ${getUserToken()}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        stopLoader(1);
        resolve(response.data);
      })
      .catch(function (error) {
        stopLoader(1);
        handleError({ error, reject });
      });
  });
};

const uploadofferStore = (file) => {
  startLoader();
  return new Promise((resolve, reject) => {
    const data = new FormData();
    data.append("file", file);

    const config = {
      method: "post",
      url: `${appConfig.apiUrl.listOfferStores}/upload`,
      headers: {
        Authorization: `Bearer ${getUserToken()}`,
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        stopLoader();
        resolve(response.data);
      })
      .catch(function (error) {
        stopLoader();
        handleError({ error, reject });
      });
  });
};

export {
  getOfferStoresList,
  getOfferStoresdataById,
  updateOfferStores,
  uploadofferStore,
};
